module.exports = __webpack_public_path__ + "brankic.8abd82a39e26f07d9549.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/brankic.ttf
// module id = 259
// module chunks = 2